<template>
  <div class="flex items-center gap-2">
    <el-popover :visible="visible" :width="260">
      <div v-if="packInfo && packInfo?.packID" :dir="$ctx.locale == 'en'? 'ltr': 'rtl'" class="flex flex-col gap-4">
        <div class="flex flex-col gap-1">
          <div>{{ t('chooseACustomPrice') }}</div>
          <el-select v-model="selectedItemPackCustomPrice" filterable class="w-full"
                     @change="selectedItemPackCustomPrice" placeholder="" value-key="id">
            <el-option v-for="(ip, j) in packInfo?.itemPack?.itemPackCustomPrices" :key="j"
                       :disabled="ip.disabled"
                       :label="$ctx.locale == 'en' ? ip.customPriceType.enName: ip.customPriceType.arName"
                       :value="ip">
            </el-option>
          </el-select>
          <div class="mt-2 font-bold text-lg" v-if="selectedItemPackCustomPrice">{{ formatMoney(selectedItemPackCustomPrice?.salePriceAmount || 0, 'IQD') }}</div>
        </div>
        <div style="text-align: right; margin: 0">
          <el-button v-if="selectedItemPackCustomPrice" text @click="clear" type="warning">{{ t('clear') }}</el-button>
          <el-button text @click="visible = false">{{ t('cancel') }}</el-button>
          <el-button :disabled="!selectedItemPackCustomPrice" type="primary" @click="confirm">
            {{ t('ok') }}
          </el-button>
        </div>
      </div>
      <div v-else :dir="$ctx.locale == 'en'? 'ltr': 'rtl'" class="flex flex-col gap-4">
        <div class="flex flex-col gap-1">
          <div>{{ t('chooseACustomPrice') }}</div>
          <el-select v-model="selectedItemCustomPrice" filterable class="w-full"
                     @change="onselectedCustomPriceChange" placeholder="" value-key="id">
            <el-option v-for="(ip, j) in item.itemCustomPrices" :key="j"
                       :disabled="ip.disabled"
                       :label="$ctx.locale == 'en' ? ip.customPriceType.enName: ip.customPriceType.arName"
                       :value="ip">
            </el-option>
          </el-select>
          <div class="mt-2 font-bold text-lg" v-if="selectedItemCustomPrice">{{ formatMoney(selectedItemCustomPrice?.salePriceAmount || 0, 'IQD') }}</div>
        </div>
        <div style="text-align: right; margin: 0">
          <el-button v-if="selectedItemCustomPrice" text @click="clear" type="warning">{{ t('clear') }}</el-button>
          <el-button text @click="visible = false">{{ t('cancel') }}</el-button>
          <el-button :disabled="!selectedItemCustomPrice" type="primary" @click="confirm">
            {{ t('ok') }}
          </el-button>
        </div>
      </div>

      <template #reference>
        <div>
          <button
              class="bg-gray-300 hover:bg-gray-500 text-black hover:text-white font-bold py-1 px-2 rounded"
              :class="{'!bg-blue-200': packInfo && packInfo?.packID? selectedItemPackCustomPrice: selectedItemCustomPrice}"
              type="button"
              v-if="item?.itemCustomPrices?.length"
              @click="visible = !visible"
          >

            <font-awesome-icon  :class="{'text-blue-500': packInfo && packInfo?.packID? selectedItemPackCustomPrice: selectedItemCustomPrice}" class=" cursor-pointer outline-none" icon="dollar-sign"
                               />
          </button>
        </div>
      </template>
    </el-popover>
  </div>
</template>
<script setup lang="ts">

import {defineEmits, defineProps, nextTick, onBeforeMount, ref} from "vue";
import {watch} from "vue-demi";
import {useI18n} from "vue-i18n";
import CustomPriceType from "@/models/inventory/CustomPrice";
import ItemCustomPrice from "@/models/inventory/ItemCustomPrice";
import {formatMoney} from "../../../utils/money";
import ItemPackCustomPrice from "@/models/inventory/ItemPackCustomPrice";

const props = defineProps(['modelValue', 'item', 'type', 'inputClass', 'packInfo', 'customPriceInfo'])
const emit = defineEmits(['update:modelValue', 'onCustomPrice'])


const messages = {
  en: {
    chooseACustomPrice: 'Choose a custom price',
    ok: 'Ok',
    cancel: 'Cancel',
    clear: 'Clear',
    single: 'Single'
  },
  ar: {
    chooseACustomPrice: 'اختر سعر مخصص',
    ok: 'موافق',
    cancel: 'الغاء',
    clear: 'السعر الاصلي',
    single: 'مفرد'
  }
}
const {t} = useI18n({messages, useScope: 'global'})

const customPriceInfoVal = ref<any|null>(null)
const packInfoVal = ref<any|null>(null)
const visible = ref(false)

const selectedItemCustomPrice = ref<ItemCustomPrice|null>()
const selectedItemPackCustomPrice = ref<ItemPackCustomPrice|null>()

onBeforeMount(() => {
  customPriceInfoVal.value = props.customPriceInfo;
  packInfoVal.value = props.packInfo;
  loadCustomPriceInfo()
})

watch(() => props.customPriceInfo, (newVal) => {
  customPriceInfoVal.value = newVal
  loadCustomPriceInfo()
}, {deep: true});

watch(() => props.packInfo, (newVal) => {
  packInfoVal.value = newVal
  loadCustomPriceInfo()
}, {deep: true});

function loadCustomPriceInfo() {
  if (customPriceInfoVal.value) {
    if (!props.packInfo || !props.packInfo?.packID) {
      let found = false;
      for (const icp of props.item.itemCustomPrices) {
        if (icp.id == customPriceInfoVal.value.itemCustomPriceID) {
          selectedItemCustomPrice.value = icp;
          found = true;
        }
      }

      if (!found) {
        selectedItemCustomPrice.value = null;
      }
    } else {
      let found = false;
      for (const icp of props.packInfo?.itemPack?.itemPackCustomPrices || []) {
        if (icp.id == customPriceInfoVal.value.itemPackCustomPriceID) {
          selectedItemPackCustomPrice.value = icp;
          found = true;
        }
      }
      if (!found) {
        selectedItemPackCustomPrice.value = null;
      }
    }

  } else {
    selectedItemCustomPrice.value = null;
    selectedItemPackCustomPrice.value = null;
  }
}

function onselectedCustomPriceChange(e: ItemCustomPrice) {
  console.log(e)
}

function confirm() {
  visible.value = false;
  const hasPackInfo = packInfoVal.value && packInfoVal.value?.packID;

  let result = {
    customPriceTypeID: hasPackInfo? selectedItemPackCustomPrice.value?.customPriceTypeID: selectedItemCustomPrice.value?.customPriceTypeID,
    type: hasPackInfo? 'pack' :'item',

    itemCustomPriceID: selectedItemCustomPrice.value? selectedItemCustomPrice.value?.id: null,
    itemCustomPrice: selectedItemCustomPrice.value? selectedItemCustomPrice.value: null,

    itemPackCustomPriceID: selectedItemPackCustomPrice.value? selectedItemPackCustomPrice.value?.id: null,
    itemPackCustomPrice: selectedItemPackCustomPrice.value? selectedItemPackCustomPrice.value: null,

    salePriceAmount: hasPackInfo?  selectedItemPackCustomPrice.value?.salePriceAmount :selectedItemCustomPrice.value?.salePriceAmount
  };

  emit('onCustomPrice', result)
}

function clear() {
  selectedItemCustomPrice.value = undefined;
  emit('onCustomPrice', null);
  visible.value = false;
}
</script>
